import { render, staticRenderFns } from "./TopEducationResultCard.vue?vue&type=template&id=753deb2c&"
import script from "./TopEducationResultCard.vue?vue&type=script&lang=ts&"
export * from "./TopEducationResultCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports